import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import { clearAccessSnapshot } from './PermissionContext';

const IDLE_TIMEOUT = 15 * 60 * 1000; // 15 minutes in milliseconds
const WARNING_TIMEOUT = 14 * 60 * 1000; // 14.5 minutes in milliseconds (30 seconds before logout)

const AutoLogout = () => {
  const navigate = useNavigate();
  const [lastActivity, setLastActivity] = useState(Date.now());
  const [showWarning, setShowWarning] = useState(false);

  const handleLogout = () => {
    // Clear all authentication related localStorage items
    localStorage.removeItem('LoginInfo');
    localStorage.removeItem('UserName');
    localStorage.removeItem('UserId');
    localStorage.removeItem('RoleId');
    localStorage.removeItem('Token');
    clearAccessSnapshot();
    // Hide warning dialog if visible
    setShowWarning(false);

    // Redirect to signin page
    navigate(all_routes.signin);
  };

  const resetTimer = () => {
    setLastActivity(Date.now());
    setShowWarning(false);
  };

  const continueSession = () => {
    resetTimer();
  };

  useEffect(() => {
    // Only set up the auto logout if user is logged in
    const isAuthenticated = localStorage.getItem('LoginInfo') !== null;
    if (!isAuthenticated) return;

    // Reset timer on user activity
    const events = [
      'mousedown', 'mousemove', 'keypress',
      'scroll', 'touchstart', 'click'
    ];

    // Add event listeners for all user interactions
    events.forEach(event => {
      window.addEventListener(event, resetTimer);
    });

    // Check for inactivity every minute
    const checkInterval = setInterval(() => {
      const currentTime = Date.now();
      const idleTime = currentTime - lastActivity;

      // Check if user has been idle for warning time
      if (idleTime > WARNING_TIMEOUT && idleTime < IDLE_TIMEOUT && !showWarning) {
        setShowWarning(true);
      }

      // Check if user has been idle for logout time
      if (idleTime > IDLE_TIMEOUT && localStorage.getItem('LoginInfo')) {
        console.log('User idle for more than 15 minutes, logging out...');
        handleLogout();
      }
    }, 10000); // Check every 10 seconds for more responsive warnings

    // Cleanup function
    return () => {
      events.forEach(event => {
        window.removeEventListener(event, resetTimer);
      });
      clearInterval(checkInterval);
    };
  }, [lastActivity, navigate, showWarning]);

  // Render warning dialog if showWarning is true
  if (showWarning) {
    return (
      <div className="auto-logout-warning">
        <div className="warning-dialog">
          <div className="warning-content">
            <h4>Session Timeout Warning</h4>
            <p>Your session will expire in 30 seconds due to inactivity.</p>
            <div className="warning-actions">
              <button className="btn btn-primary" onClick={continueSession}>
                Continue Session
              </button>
              <button className="btn btn-secondary" onClick={handleLogout}>
                Logout Now
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Return null when no warning is shown
  return null;
};

export default AutoLogout; 